import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';

import css from 'css';

import { gtmPush } from 'helpers';

import { h2Styles } from 'partials/typography';
import AnimateIn from 'partials/AnimateIn';

import {
    addCheckoutOpportunityCourse,
    addCheckoutOpportunityProgram,
} from 'store';

const Wrapper = styled.div``

const Title = styled.h2`
    ${h2Styles}
    margin-bottom: 30px;
    ${props => props.pageBackground === 'main' ? `
        padding-top:20px;
    ` : ``}
`

const ProductList = styled.div`
    position: relative;
    flex: 0 0 100%;
    max-width: 100%;
`;

const ProductItem = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    justify-content: space-between;
    padding: 15px;

    &:hover {
        background-color: ${css.colors.pink};
    }

    @media (min-width: 1100px) {
        align-items: center;
        flex-direction: row;
    }


    > .description {
        display: flex;
        flex: 0 0 40%;
        flex-flow: column;
        padding: 0 15px;

        @media (min-width: 1100px) {
            padding: 0;
        }
    
        .name {
            padding-bottom: 5px;
            font-weight: bold;
        }
    }

    > .totals {
        display: flex;
        flex: 0 0 30%;
        flex-flow: column;
        padding: 0 15px;

        @media (min-width: 1100px) {
            padding: 0;
        }

        .price {
            padding-left: 10px;
        }

        .full-price {
            align-items: center;

            @media (min-width: 1100px) {
                flex-direction: row-reverse;
            }

            .description {
                @media (min-width: 1100px) {
                    display: none;
                }
            }

            .price {
                font-weight: bold;
            }
        }

        & > div {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    > .action {
        button {
            width: 100%;
            background: ${css.colors.blue};
            padding: 10px 15px;
            margin-top: 10px;
            border-radius: 25px;
            color: white;
            text-align: start;
            cursor: pointer;

            @media (min-width: 1100px) {
                text-align: center;
                width: 100px;
                margin-top: 0;
            }

            &:disabled {
                text-indent: -9999px;
                cursor: initial;

                &:before {
                    position: absolute;
                    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTYgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QYWdlIDEgQ29weTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iY2hlY2tib3hfY2hlY2tlZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuMDAwMDAwLCAtNy4wMDAwMDApIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGFnZS0xLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjAwMDAwMCwgMTIuNTAwMDAwKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTIuMDAwMDAwLCAtMTIuNTAwMDAwKSAiIHBvaW50cz0iNy41IDUuNSAxNi41IDE0LjMyMjMzMzIgMTEuMjc4MTk4MiAxOS41Ij48L3BvbHlsaW5lPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+') no-repeat;
                    background-position: center left;
                    width: 100%;
                    height: 1em;
                    left: 15px;
                    content: "";

                    @media (min-width: 1100px) {
                        background-position: center center;
                        left: 0;
                    }
                }
            }
        }
    }
`;

class Courses extends Component {
    componentDidMount() {
        api.coursesFetcher.getAll();
        api.programsFetcher.getAll();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _onAddToCartClick(product) {
        this._onAddCartItemTracking(product);

        switch (product.objectType) {
            case 'program':
                this.props.addCheckoutOpportunityProgram(product);
                break;
            case 'course':
                this.props.addCheckoutOpportunityCourse(product);
                break;
        }
    }

    _onAddCartItemTracking(product) {
        gtmPush({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'NOK',
                'add': {
                    'products': [{
                        'name': product.name,
                        'id': product.id,
                        'price': product.price,
                        'brand': 'bjorknesprivatskole',
                        'category': product.academicArea || product.category || '',
                        'variant': product.semester,
                        'quantity': 1
                    }]
                }
            }
        });
    }

    _isInCart(product) {
        const { courses, programs } = this.props.opportunity;

        switch (product.objectType) {
            case 'program':
                return programs.filter(item => item.id === product.id).length;
            case 'course':
                return courses.filter(item => item.offeringId === product.offeringId).length;
        }
    }

    _filterProdutsToList(filter) {
        const { courses, programs } = this.props;

        let productList = [];

        filter.forEach(item => {
            if ('courses' === item.post_type) {
                courses.forEach(course => {
                    course.objectType = 'course';

                    if (course.id === item.acf.integration_id) {
                        productList.push(course);

                        return;
                    }
                });
            }

            if ('programs' === item.post_type) {
                programs.forEach(program => {
                    program.objectType = 'program';

                    if (program.id === item.acf.integration_id) {
                        productList.push(program);

                        return;
                    }
                });
            }
        });

        productList.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            if(a.semester < b.semester) {
                return -1;
            }

            if(a.semester > b.semester) {
                return 1;
            }
            return 0;
        });

        return productList;
    }

    render() {
        const { data, pageBackground, title } = this.props;

        if (!data) {
            return null;
        }

        const products = this._filterProdutsToList(data);

        return (
            <AnimateIn>
                <Wrapper>
                    {title &&
                        <Title pageBackground={pageBackground}>{title}</Title>
                    }

                    <ProductList>
                        {products.map(product => {
                            const inCart = this._isInCart(product);

                            return (
                                <ProductItem key={'product-' + product.id}>
                                    <div className="description">
                                        <div className="name">
                                            <span dangerouslySetInnerHTML={{ __html: product.name }} />
                                        </div>
                                    </div>
                                    <div className="totals">
                                        <div className="full-price">
                                            <span className="description"> Pris </span>
                                            <span className="price"> {parseInt(product.price).toLocaleString('de-DE')},- </span>
                                        </div>
                                    </div>
                                    <div className="action">
                                        <button onClick={e => this._onAddToCartClick(product)} disabled={inCart}> Legg til </button>
                                    </div>
                                </ProductItem>
                            )
                        })}
                    </ProductList>
                </Wrapper>
            </AnimateIn>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
    courses: state.courses.posts,
    programs: state.programs.posts,
});

const actions = {
    addCheckoutOpportunityCourse,
    addCheckoutOpportunityProgram,
}

export default connect(mapStateToProps, actions)(Courses);



// WEBPACK FOOTER //
// ./src/partials/modules/Widgets/Courses/Courses.js